import { render, staticRenderFns } from "./remoteControl.vue?vue&type=template&id=656ffb52&scoped=true&"
import script from "./remoteControl.vue?vue&type=script&lang=js&"
export * from "./remoteControl.vue?vue&type=script&lang=js&"
import style0 from "./remoteControl.vue?vue&type=style&index=0&id=656ffb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ffb52",
  null
  
)

export default component.exports